import React, { useState } from 'react'
import { NavLink, Link } from 'react-router-dom'
import './HomeNavigation.css'
import HomeHeader from './HomeHeader'
import HomeNavLinks from './HomeNavLinks'
import SideDrawer from '../../../admin/components/SideDrawer'
import Backdrop from '../UIElements/Backdrop'
import schedulesLogo from '../../../images/schedules_transparent.png'
import k_logo from '../../../images/K_logo_transparent.png'

const SchedulesHomeNavigation = (props) => {
	const [drawerIsOpen, setDrawerIsOpen] = useState(false)

	/* console.log(
		'SchedulesHomeNavigation props: ' + JSON.stringify(props.leagueId)
	) */

	const openDrawerHandler = () => {
		setDrawerIsOpen(true)
	}

	const closeDrawerHandler = () => {
		setDrawerIsOpen(false)
	}

	return (
		<React.Fragment>
			{drawerIsOpen && <Backdrop onClick={closeDrawerHandler} />}
			<SideDrawer show={drawerIsOpen} onClick={closeDrawerHandler}>
				<nav className='home-navigation__drawer-nav'>
					<HomeNavLinks leagueId={props.leagueId} />
				</nav>
			</SideDrawer>
			<HomeHeader>
				<button
					className='home-navigation__menu-btn'
					onClick={openDrawerHandler}
				>
					<span />
					<span />
					<span />
				</button>
				{/* <h1 className='home-navigation__title'>
					<Link to='/schedule' style={{ textShadow: 'black 2px 2px 2px' }}>
						Schedules
					</Link>
				</h1> */}
				<div className='headerWidth'>
					<img src={schedulesLogo} className='headerLogo' />
					<a
						href='https://knapperusa.com/'
						target='_blank'
						rel='noopener noreferrer'
					>
						<img src={k_logo} className='k_schedules_Logo' alt='Knapper USA' />
					</a>
				</div>
				<nav className='home-navigation__header-nav'>
					<HomeNavLinks leagueId={props.leagueId} />
				</nav>
			</HomeHeader>
			{/* <SelectLeague /> */}
		</React.Fragment>
	)
}

export default SchedulesHomeNavigation
